import { SliderProps } from '@mui/material';
import { flowSlider } from './slider.theme';

/**
 * Generate * amount of marks for the slider
 *
 * Usage:
 *  const marks = getSliderMarks(min, max)
 *  <Slider marks={marks} />
 */
export function getSliderMarks(
  min: SliderProps['min'] = flowSlider.defaultProps.min,
  max: SliderProps['max'] = flowSlider.defaultProps.max,
  amount: number = 12,
  skipFirstAndLast: boolean = false,
) {
  return [...new Array(amount)].map((_, idx) => {
    // obtain percentage of the current index
    const percentage = skipFirstAndLast ? (100 / (amount + 1)) * (idx + 1) : (100 / (amount - 1)) * idx;
    // calculate value include floating point fix
    return { value: Math.round((percentage * ((max - min) / 100) + min + Number.EPSILON) * 1000) / 1000 };
  });
}
